import { useRef } from "react";
import { useGlobalContext } from "../context";

function SearchForm() {
  const { setSearch } = useGlobalContext();
  const searchValue = useRef();

  const getSearch = () => {
    setSearch(searchValue.current.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <div
      id="goto-top"
      style={{
        marginTop: "7rem",
        backgroundColor: "#889ebf",
        padding: "2rem",
        marginLeft: "1rem",
        marginRight: "1rem",
        borderRadius: "1rem",
      }}
    >
      <div className="jumbotron">
        <h1 className="display-4">
          Hi there, welcome to <span className="text-primary">GroXeries</span>!
        </h1>
        <p className="lead">
          With <b>Groxeries</b> you can order grocery items at your door step.
          Get groceries at lesser price than a typical shopping mart!
        </p>
        <hr className="my-4" />
        <p className="fw-light">Search using a product name or by category</p>
        <form onSubmit={handleSubmit}>
          <div className="form-control d-flex justify-content-center">
            <input
              type="text"
              name="name"
              id="name"
              ref={searchValue}
              onChange={getSearch}
              className="form-control"
              placeholder="Search a grocery item"
              style={{ textAlign: "center" }}
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export default SearchForm;
